import { render, staticRenderFns } from "./ExplanationPage.vue?vue&type=template&id=4bb82d81&scoped=true&"
import script from "./ExplanationPage.vue?vue&type=script&lang=js&"
export * from "./ExplanationPage.vue?vue&type=script&lang=js&"
import style0 from "./ExplanationPage.vue?vue&type=style&index=0&id=4bb82d81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb82d81",
  null
  
)

export default component.exports